import Shop from "@/components/shop/shop";
import ProductDetails from "@/components/products/product-details";
import Cart from "@/components/cart/cart";
import Checkout from "@/components/checkout/checkout";
import ContactUs from "@/components/contact/contact-us";
import AllReviews from "@/components/pages/all-reviews";
import BlogListing from "@/components/blog/blog-list";
import BlogDetails from "@/components/blog/blog-details";
import Maintenance from "@/components/maintenance/maintenance";
import TrackOrderPage from "@/components/pages/track-order";
import AboutUs from "@/components/about/about";
import PrivacyPolicy from "@/components/legal/privacy-policy";
import RefundPolicy from "@/components/legal/refund-policy";
import TermsOfService from "@/components/legal/terms-of-services";
import FAQ from "@/components/pages/faq";
import Newsletter from "@/components/pages/newsletter";
import PaymentCallback from "@/components/payment/payment-callback";
import GiftCollection from "@/components/gifts/gift-collection";

export const publicRoutes = [
  { path: "/shop", element: <Shop /> },
  { path: "/gifts", element: <GiftCollection /> },
  { path: "/products/:productId", element: <ProductDetails /> },
  { path: "/cart", element: <Cart /> },
  { path: "/checkout", element: <Checkout /> },
  { path: "/payment/callback", element: <PaymentCallback /> },
  { path: "/about-us", element: <AboutUs /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/reviews", element: <AllReviews /> },
  { path: "/blogs", element: <BlogListing /> },
  { path: "/blog/:slug", element: <BlogDetails /> },
  { path: "/maintenance", element: <Maintenance /> },
  { path: "/track-order", element: <TrackOrderPage /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/refund-policy", element: <RefundPolicy /> },
  { path: "/terms-of-service", element: <TermsOfService /> },
  { path: "/newsletter", element: <Newsletter /> },
];
